/* eslint-disable complexity */
const mapOtherData = (data, orders, bundles) => {
  const [formattedData] = data;
  const newArr = [];
  let returnArr = [];

  orders.map((item) => {
    if (item.miscInfo.TCPPromotions === formattedData.TCPPromotions) {
      newArr.push({
        quantity: item.itemInfo.quantity,
        TCPPromotions: item.miscInfo.TCPPromotions,
        c_TCPimages: item.productInfo.imagePath,
        pdpUrl: item.productInfo.pdpUrl,
        productId: item.productInfo?.generalProductId,
        brand: item.productInfo?.itemBrand,
      });
    }
    return null;
  });
  const restArr =
    bundles &&
    bundles.filter((bundle) => {
      return bundle.TCPPromotions !== formattedData.TCPPromotions;
    });
  returnArr = [...newArr, ...restArr];
  return returnArr;
};

const whenQtyDecreasedFromCart = (data, productId) => {
  const updateData = [];
  const sameprod = data.filter((item) => item.productId === productId);
  const diffprod = data.filter((item) => item.productId !== productId);

  let qty = 0;
  sameprod.forEach((item) => {
    qty += item.quantity;
  });
  updateData.push({
    TCPPromotions: sameprod[0].TCPPromotions,
    c_TCPimages: sameprod[0].c_TCPimages,
    pdpUrl: sameprod[0].pdpUrl,
    productId: sameprod[0].productId,
    quantity: qty,
    brand: sameprod[0].c_brand,
  });
  return [...updateData, ...diffprod];
};

// this function keeps track of current added product in bag in order to maintain latest 2 bundle selection
// eslint-disable-next-line sonarjs/cognitive-complexity
export const formatBundleData = (response, ordersList = [], bundleDataItems = []) => {
  const res =
    response?.data?.addItemsInNewBasket?.productItems ||
    response?.data?.removeItemFromBasket?.productItems ||
    response?.data?.removeItemListFromBasket?.productItems ||
    response?.data?.updateBackpackItemInBasket?.productItems ||
    response?.data?.updateItemInBasket?.productItems ||
    response?.data?.addStoreItems?.productItems ||
    response?.data?.updateStoreItemInBasket?.productItems;

  const operationName = Object.keys(response?.data);
  const removeCall = operationName.some(
    (operation) => operation === 'removeItemFromBasket' || operation === 'removeItemListFromBasket'
  );

  let updatedProductId;

  const orders = ordersList && JSON.parse(JSON.stringify(ordersList));
  const bundles = bundleDataItems && JSON.parse(JSON.stringify(bundleDataItems));
  let formattedData = [];
  if (orders && orders.length === 0) {
    res.map((item) => {
      formattedData.push({
        quantity: item?.quantity,
        TCPPromotions: item?.TCPPromotions || item?.c_bundlePromoId,
        c_TCPimages: item?.c_TCPimages,
        pdpUrl: `/us/p/${item?.c_prodPartNo}`,
        productId: item?.productId,
        brand: item?.c_brand,
      });
      return null;
    });
    return formattedData;
  }
  for (let i = 0; i < res.length; i += 1) {
    for (let j = 0; j < orders.length; j += 1) {
      if (
        res[i]?.productId === orders[j]?.productInfo?.generalProductId &&
        res[i]?.quantity !== orders[j]?.itemInfo?.quantity
      ) {
        const mismatchedQuantity = res[i].quantity - orders[j].itemInfo.quantity;
        updatedProductId = res[i]?.productId;
        formattedData.push({
          quantity: mismatchedQuantity,
          TCPPromotions: res[i]?.TCPPromotions || res[i]?.c_bundlePromoId,
          c_TCPimages: res[i]?.c_TCPimages,
          pdpUrl: `/us/p/${res[i]?.c_prodPartNo}`,
          productId: res[i]?.productId,
          brand: res[i]?.c_brand,
        });
        const data = mapOtherData(formattedData, orders, bundles);
        formattedData = [...formattedData, ...data];
        if (mismatchedQuantity < 0) {
          return whenQtyDecreasedFromCart(formattedData, updatedProductId);
        }
        return formattedData;
      }
    }
  }
  if (res?.length === 0) {
    return [];
  }
  if (res && res.length === 1) {
    const formattedNewData = {
      quantity: res[0]?.quantity,
      TCPPromotions: res[0]?.TCPPromotions || res[0]?.c_bundlePromoId,
      c_TCPimages: res[0]?.c_TCPimages,
      pdpUrl: `/us/p/${res[0]?.c_prodPartNo}`,
      productId: res[0]?.productId,
      brand: res[0]?.c_brand,
    };
    // When Item is removed, res gives back array with multiple items, this will come when second last item is removed
    if (removeCall) {
      return [formattedNewData];
    }
    return bundles && bundles.length > 0 ? [formattedNewData, ...bundles] : [formattedNewData];
  }
  // will work for remove Item case.
  if (res && res.length > 1) {
    return res?.map((item) => {
      return {
        quantity: item?.quantity,
        TCPPromotions: item?.c_bundlePromoId,
        c_TCPimages: item?.c_TCPimages,
        pdpUrl: `/us/p/${item?.c_prodPartNo}`,
        productId: item?.productId,
        brand: item?.c_brand,
      };
    });
  }
  return null;
};

export default {
  formatBundleData,
};
